import {TestimonialBubble} from 'components/Testimonial';
import React, {useState} from 'react';
import {Carousel, CarouselItem, CarouselControl, CarouselIndicators, CarouselCaption} from 'reactstrap';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faAngleLeft} from '@fortawesome/pro-regular-svg-icons/faAngleLeft';
import {faAngleRight} from '@fortawesome/pro-regular-svg-icons/faAngleRight';

import Video from 'components/Video';

import {studentSpotlight} from 'data/testimonials.json';

import './SpotlightCarousel.scss';

export default function SpotlightCarousel({args = null}) {
  const [activeIndex, setActiveIndex] = useState(0);
  const [animating, setAnimating] = useState(false);

  const next = () => {
    if (animating) return;
    const nextIndex = activeIndex === studentSpotlight.length - 1 ? 0 : activeIndex + 1;
    setActiveIndex(nextIndex);
  };

  const previous = () => {
    if (animating) return;
    const nextIndex = activeIndex === 0 ? studentSpotlight.length - 1 : activeIndex - 1;
    setActiveIndex(nextIndex);
  };

  const goToIndex = (newIndex) => {
    if (animating) return;
    setActiveIndex(newIndex);
  };

  const slides = studentSpotlight.map((listItem, i) => {
    return (
      <CarouselItem
        className="p-1"
        onExiting={() => setAnimating(true)}
        onExited={() => setAnimating(false)}
        key={'slide' + i}
      >
        <div className="background-white d-flex flex-column flex-grow-1 box-shadow-black-50 rounded-top">
          <div className="my-auto p-3">
            <p className="mb-2">
              <b>{listItem.name}</b>
            </p>
            <p className="text-balance mb-0">{listItem.title}</p>
          </div>
          <div className="spotlight-video">
            <Video url={listItem.videoUrl} label={`pbcc student spotlight ${listItem.name}`} />
          </div>
        </div>
      </CarouselItem>
    );
  });

  return (
    <Carousel
      activeIndex={activeIndex}
      next={next}
      previous={previous}
      interval={false}
      className="testimonials-carousel d-flex align-items-center"
      {...args}
    >
      <CarouselControl direction="prev" directionText="Previous" onClickHandler={previous} />
      {slides}
      <CarouselControl direction="next" directionText="Next" onClickHandler={next} />
      <CarouselIndicators items={studentSpotlight} activeIndex={activeIndex} onClickHandler={goToIndex} />
    </Carousel>
  );
}
